/**
 * Every amount on the site.
 *
 * Amounts arrive as integer cents and are rendered in tabular figures, so a
 * column of money lines up digit for digit and a figure that ticks upward does
 * not shift the layout around it. The element carries the machine-readable
 * value too, which is what a screen reader and a copy-paste both want.
 */

import type { ReactNode } from 'react';

import { formatMoneyCents } from '../lib/format';

export type MoneySize = 'inherit' | 'small' | 'medium' | 'large' | 'display';

const SIZE_CLASS: Record<MoneySize, string> = {
  inherit: '',
  small: ' is-small',
  medium: ' is-medium',
  large: ' is-large',
  display: ' is-display',
};

export function Money({
  cents,
  size = 'inherit',
  currency = 'USD',
  className,
  title,
}: {
  readonly cents: number;
  readonly size?: MoneySize;
  readonly currency?: string;
  readonly className?: string;
  readonly title?: string;
}): ReactNode {
  const formatted = formatMoneyCents(cents, currency);
  return (
    <span
      className={`money${SIZE_CLASS[size]}${className === undefined ? '' : ` ${className}`}`}
      title={title}
    >
      {formatted}
    </span>
  );
}
